export const decodeErrorText = (value: unknown): string => {
  if (value == null) return '';

  if (typeof value === 'object') {
    const record = value as { message?: unknown; msg?: unknown };
    if ('message' in record || 'msg' in record) {
      return decodeErrorText(record.message ?? record.msg);
    }
    return '';
  }

  let text = String(value).replace(/\+/g, ' ').trim();

  for (let attempt = 0; attempt < 2; attempt += 1) {
    if (!/%[0-9A-Fa-f]{2}/.test(text)) break;

    try {
      const decoded = decodeURIComponent(text);
      if (decoded === text) break;
      text = decoded;
    } catch {
      break;
    }
  }

  return text;
};
